(function () {
  if (window.__tw3Pages) return;
  window.__tw3Pages = true;

  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function lock(on) { document.documentElement.classList.toggle('tw3-lock', on); }

  /* ---------- Hauteur de l'en-tête collant (pour les barres collantes) ---------- */
  function stickTop() {
    var h = 0;
    $all('.shopify-section-group-header-group').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position === 'sticky' || cs.position === 'fixed') {
        var r = el.getBoundingClientRect();
        if (r.bottom > h && r.top <= 1) h = r.bottom;
      }
    });
    var hd = document.querySelector('sticky-header, .header-wrapper, #shopify-section-header');
    if (hd) {
      var r2 = hd.getBoundingClientRect();
      var cs2 = getComputedStyle(hd);
      if ((cs2.position === 'sticky' || cs2.position === 'fixed') && r2.top <= 1 && r2.bottom > h) h = r2.bottom;
    }
    document.documentElement.style.setProperty('--tw3-stick', Math.max(0, Math.round(h)) + 'px');
  }
  window.addEventListener('scroll', stickTop, { passive: true });
  window.addEventListener('resize', stickTop);
  document.addEventListener('DOMContentLoaded', stickTop);

  /* ---------- Tri ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-tw3-sort]');
    if (!sel) return;
    var u = new URL(window.location.href);
    u.searchParams.set('sort_by', sel.value);
    u.searchParams.delete('page');
    window.location.href = u.toString();
  });

  /* ---------- Filtres de collection ---------- */
  function initColl(root) {
    if (!root || root.__tw3) return;
    root.__tw3 = true;
    var items = $all('.tw3-cgrid__i', root);
    var facets = root.querySelector('[data-tw3-facets]');
    var count = root.querySelector('[data-tw3-count]');
    var chips = root.querySelector('[data-tw3-chips]');
    var none = root.querySelector('[data-tw3-none]');
    var see = root.querySelector('[data-tw3-fsee]');
    var badge = root.querySelector('[data-tw3-fbadge]');
    var total = items.length;

    function state() {
      var st = { fmt: [], col: [], pmin: null, pmax: null, labels: [] };
      $all('[data-tw3-f="fmt"]:checked', root).forEach(function (i) { st.fmt.push(i.value); st.labels.push({ el: i, label: i.getAttribute('data-label') }); });
      $all('[data-tw3-f="col"]:checked', root).forEach(function (i) { st.col.push(i.value); st.labels.push({ el: i, label: i.getAttribute('data-label') }); });
      var mn = root.querySelector('[data-tw3-f="pmin"]'), mx = root.querySelector('[data-tw3-f="pmax"]');
      if (mn && mn.value !== '') { st.pmin = parseFloat(mn.value) * 100; st.labels.push({ el: mn, label: 'Dès ' + mn.value + ' €' }); }
      if (mx && mx.value !== '') { st.pmax = parseFloat(mx.value) * 100; st.labels.push({ el: mx, label: "Jusqu'à " + mx.value + ' €' }); }
      return st;
    }

    function apply() {
      var st = state(), n = 0;
      items.forEach(function (it) {
        var ok = true;
        if (st.fmt.length && st.fmt.indexOf(it.getAttribute('data-fmt')) < 0) ok = false;
        if (ok && st.col.length) {
          var c = it.getAttribute('data-col') || '';
          ok = st.col.some(function (v) { return c.indexOf('|' + v + '|') > -1; });
        }
        var p = parseInt(it.getAttribute('data-price'), 10) || 0;
        if (ok && st.pmin !== null && p < st.pmin) ok = false;
        if (ok && st.pmax !== null && p > st.pmax) ok = false;
        it.hidden = !ok;
        if (ok) n++;
      });
      if (count) count.textContent = n + (n > 1 ? ' produits' : ' produit');
      if (none) none.hidden = n > 0 || total === 0;
      if (see) see.textContent = n > 1 ? 'Voir les ' + n + ' produits' : (n === 1 ? 'Voir le produit' : 'Aucun produit');
      if (badge) badge.textContent = st.labels.length ? ' (' + st.labels.length + ')' : '';
      if (chips) {
        chips.innerHTML = '';
        st.labels.forEach(function (l) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'tw3-achip';
          b.setAttribute('aria-label', 'Retirer le filtre ' + l.label);
          b.innerHTML = '<span></span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
          b.firstChild.textContent = l.label;
          b.addEventListener('click', function () {
            if (l.el.type === 'checkbox') l.el.checked = false; else l.el.value = '';
            apply();
          });
          chips.appendChild(b);
        });
        if (st.labels.length > 1) {
          var c = document.createElement('button');
          c.type = 'button'; c.className = 'tw3-ulink'; c.textContent = 'Tout effacer';
          c.addEventListener('click', clear);
          chips.appendChild(c);
        }
      }
    }
    function clear() {
      $all('[data-tw3-f]', root).forEach(function (i) { if (i.type === 'checkbox') i.checked = false; else i.value = ''; });
      apply();
    }
    root.addEventListener('change', function (e) { if (e.target.matches('[data-tw3-f]')) apply(); });
    root.addEventListener('input', function (e) { if (e.target.matches('[data-tw3-f="pmin"],[data-tw3-f="pmax"]')) apply(); });
    $all('[data-tw3-fclear]', root).forEach(function (b) { b.addEventListener('click', clear); });

    function open() { if (!facets) return; facets.classList.add('is-open'); facets.setAttribute('aria-modal', 'true'); lock(true); var f = facets.querySelector('.tw3-x'); if (f) f.focus(); }
    function close() { if (!facets) return; facets.classList.remove('is-open'); facets.setAttribute('aria-modal', 'false'); lock(false); }
    $all('[data-tw3-fopen]', root).forEach(function (b) { b.addEventListener('click', open); });
    $all('[data-tw3-fclose]', root).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && facets && facets.classList.contains('is-open')) close(); });
    apply();
  }

  /* ---------- Texte replié sur téléphone ---------- */
  function initMore() {
    $all('[data-tw3-more]').forEach(function (b) {
      if (b.__tw3) return; b.__tw3 = true;
      var btn = b.parentNode.querySelector('[data-tw3-more-btn]');
      if (!btn || window.innerWidth > 767) return;
      b.classList.add('is-clamped');
      if (b.scrollHeight <= b.clientHeight + 4) { b.classList.remove('is-clamped'); return; }
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var c = b.classList.toggle('is-clamped');
        btn.textContent = c ? 'Lire la suite' : 'Réduire';
      });
    });
  }

  function init(scope) {
    $all('[data-tw3-coll]', scope).forEach(initColl);
    initMore();
    if (window.TW3Product) window.TW3Product(scope || document);
    stickTop();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.TW3Init = init;
})();

/* ---------- Fiche produit ---------- */
(function () {
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function money(c) { return (c / 100).toFixed(2).replace('.', ',') + ' €'; }
  function addDays(n) {
    var d = new Date(), k = 0;
    while (k < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) k++; }
    return d;
  }
  var MOIS = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
  function fmt(d) { return d.getDate() + ' ' + MOIS[d.getMonth()]; }

  function initProduct(root) {
    if (root.__tw3) return; root.__tw3 = true;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-tw3-pjson]').textContent); } catch (e) {}
    var track = root.querySelector('[data-tw3-track]');
    var slides = track ? $all('.tw3-gal__slide', track) : [];
    var ths = $all('[data-tw3-th]', root);
    var count = root.querySelector('[data-tw3-gcount]');
    function setCur(i) {
      ths.forEach(function (t, k) { if (k === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }
    function go(i) { if (!track || !slides[i]) return; track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setCur(i); }
    ths.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.getAttribute('data-tw3-th'), 10)); }); });
    if (track) {
      var to;
      track.addEventListener('scroll', function () {
        clearTimeout(to);
        to = setTimeout(function () { var i = Math.round(track.scrollLeft / track.clientWidth); setCur(Math.max(0, Math.min(slides.length - 1, i))); }, 60);
      }, { passive: true });
      track.addEventListener('keydown', function (e) {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (e.key === 'ArrowRight') { e.preventDefault(); go(Math.min(slides.length - 1, i + 1)); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(Math.max(0, i - 1)); }
      });
    }

    /* délai de livraison estimé */
    var eta = root.querySelector('[data-tw3-eta]');
    if (eta) {
      var a = parseInt(eta.getAttribute('data-min'), 10) || 3, b = parseInt(eta.getAttribute('data-max'), 10) || 6;
      eta.textContent = 'Livraison estimée entre le ' + fmt(addDays(a)) + ' et le ' + fmt(addDays(b));
    }

    /* variantes */
    var form = root.querySelector('[data-tw3-pform]');
    var vid = root.querySelector('[data-tw3-vid]');
    var price = root.querySelector('[data-tw3-price]');
    var cmp = root.querySelector('[data-tw3-compare]');
    var addb = root.querySelector('[data-tw3-addbtn]');
    var addl = root.querySelector('[data-tw3-addlabel]');
    var sadd = root.querySelector('[data-tw3-sadd]');
    var sprice = root.querySelector('[data-tw3-sprice]');
    var stock = root.querySelector('[data-tw3-stock]');
    var dot = root.querySelector('[data-tw3-dot]');
    var left = root.querySelector('[data-tw3-left]');
    var free = parseInt(root.getAttribute('data-free'), 10) || 5000;
    var cartTotal = parseInt(root.getAttribute('data-cart'), 10) || 0;
    var stockText = stock ? stock.textContent : '';
    var fsets = $all('[data-tw3-opt]', root);
    function current() {
      var sel = fsets.map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; });
      return (data.variants || []).filter(function (v) { return v.options.every(function (o, k) { return sel[k] === null || o === sel[k]; }); })[0];
    }
    function update(v, move) {
      if (!v) return;
      if (vid) vid.value = v.id;
      if (price) price.textContent = money(v.price);
      if (sprice) sprice.textContent = money(v.price);
      if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = v.compare_at_price ? money(v.compare_at_price) : ''; }
      if (addb) addb.disabled = !v.available;
      if (sadd) sadd.disabled = !v.available;
      if (addl) addl.textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      if (stock) stock.textContent = v.available ? stockText : 'Épuisé pour le moment';
      if (dot) dot.classList.toggle('tw3-info__dot--off', !v.available);
      if (left) { var l = free - cartTotal - v.price; left.textContent = l > 0 ? "Offerte dès " + (free / 100) + " € d'achat · encore " + money(l) + ' avec ce produit' : 'Livraison offerte en point relais avec ce produit'; }
      fsets.forEach(function (fs, k) { var o = fs.querySelector('[data-tw3-optval]'); if (o) o.textContent = v.options[k]; });
      if (move && v.featured_media) {
        var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
        if (idx > -1) go(idx);
      }
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    }
    fsets.forEach(function (fs) { fs.addEventListener('change', function () { update(current(), true); }); });

    /* quantité */
    var qin = root.querySelector('[data-tw3-qtyin]');
    $all('[data-tw3-qty]', root).forEach(function (b) {
      b.addEventListener('click', function () { var q = (parseInt(qin.value, 10) || 1) + parseInt(b.getAttribute('data-tw3-qty'), 10); qin.value = Math.max(1, q); });
    });

    /* option plaque personnalisée : change le libellé du bouton */
    var perso = root.querySelector('[data-tw3-perso]');
    if (perso) {
      var lbl = root.querySelector('[data-tw3-addlabel]');
      var dyn = root.querySelector('.tw3-buy__dyn');
      perso.addEventListener('change', function () {
        /* avec la plaque, le paiement express sauterait l'étape de gravure : on le masque */
        if (dyn) dyn.hidden = perso.checked;
        if (!lbl || (addb && addb.disabled)) return;
        lbl.textContent = perso.checked ? (perso.getAttribute('data-tw3-perso-btn') || 'Ajouter et créer ma plaque') : 'Ajouter au panier';
        if (perso.checked && (lbl.scrollWidth > lbl.clientWidth + 1 || (addb && addb.scrollWidth > addb.clientWidth + 1))) lbl.textContent = 'Ajouter et graver';
      });
    }

    /* ajout au panier */
    var err = root.querySelector('[data-tw3-perr]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (addb) addb.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root_ + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(vid.value), quantity: Math.max(1, parseInt(qin.value, 10) || 1) }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Ajout impossible'); return j; }); })
        .then(function () {
          var pc = root.querySelector('[data-tw3-perso]');
          if (pc && pc.checked) {
            var dlg = document.getElementById('tw3-plaque-dialog');
            if (dlg && typeof dlg.showModal === 'function') {
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: false } }));
              pc.checked = false; pc.dispatchEvent(new Event('change'));
              dlg.showModal();
              return;
            }
            window.location.href = pc.getAttribute('data-tw3-perso'); return;
          }
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
        })
        .catch(function (x) { if (err) { err.textContent = x.message || 'Ajout impossible'; err.hidden = false; } })
        .then(function () { if (addb) addb.removeAttribute('aria-busy'); });
    });

    /* barre d'achat collante (téléphone) */
    var bar = root.querySelector('[data-tw3-sbar]');
    if (bar && addb) {
      if (sadd) sadd.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); });
      var ticking = false;
      function check() {
        ticking = false;
        var r = addb.getBoundingClientRect();
        var show = r.bottom < 0 || r.top > window.innerHeight - 8;
        if (bar.classList.contains('is-on') === show) return;
        bar.classList.toggle('is-on', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (sadd) sadd.tabIndex = show ? 0 : -1;
        document.body.classList.toggle('tw3-has-sbar', show);
      }
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } });
      check();
    }
    update(current() || (data.variants || [])[0], false);
  }
  window.TW3Product = function (scope) { $all('[data-tw3-product]', scope).forEach(initProduct); };
  if (document.readyState !== 'loading') window.TW3Product(document);
})();

/* Puces de navigation : puce active visible au chargement, fondu tant qu'il reste des puces à droite */
(function(){
  function init(){
    document.querySelectorAll('.tw3-tchips').forEach(function(n){
      var a=n.querySelector('[aria-current]');
      if(a&&n.scrollWidth>n.clientWidth){
        var ar=a.getBoundingClientRect(),nr=n.getBoundingClientRect();
        if(ar.right>nr.right-8){n.scrollLeft+=ar.left-nr.left-16;}
      }
      function u(){n.classList.toggle('is-more',n.scrollWidth-n.clientWidth-n.scrollLeft>4);}
      u();n.addEventListener('scroll',u,{passive:true});window.addEventListener('resize',u);
    });
  }
  if(document.readyState!=='loading'){init();}else{document.addEventListener('DOMContentLoaded',init);}
})();
